import { rootPrefix } from '#/routing/routes';

export const redirectToSavedSearchPath = rootPrefix.path(
  'saved-searches/:savedSearchId',
);

/**
 * This is not a real path - the path is defined using constants instead of :lang/:segment
 * so that they're more accurate and easier to understand
 */
export const searchJobsPathReference = rootPrefix.path('-lang/-segment', [
  // sorted alphabetically
  'areasOfFocus',
  'education',
  'functions',
  'hasSalary',
  'jobType',
  'locale',
  'location',
  'locationType',
  'orgType',
  'page',
  'professionalLevel',
  'q',
  'radius',
  'recency',
  'sort',
  'synonymId',
]);

/**
 * This is not a real path - the path is defined using constants instead of :lang/:segment
 * so that they're more accurate and easier to understand
 */
export const searchInternshipsPathReference = rootPrefix.path(
  '-lang/-segment',
  [
    // sorted alphabetically
    'areasOfFocus',
    'functions',
    'locale',
    'location',
    'locationType',
    'orgType',
    'page',
    'payment',
    'q',
    'radius',
    'recency',
    'sort',
    'synonymId',
  ],
);

/**
 * This is not a real path - the path is defined using constants instead of :lang/:segment
 * so that they're more accurate and easier to understand
 */
export const searchVolopsPathReference = rootPrefix.path('-lang/-segment', [
  // sorted alphabetically
  'areasOfFocus',
  'canBeDoneInADay',
  'endsGT',
  'functions',
  'locale',
  'location',
  'locationType',
  'page',
  'q',
  'radius',
  'recency',
  'sort',
  'source',
  'startsLT',
  'welcome',
]);

/**
 * This is not a real path - the path is defined using constants instead of :lang/:segment
 * so that they're more accurate and easier to understand
 */
export const searchEventsPathReference = rootPrefix.path('-lang/-segment', [
  // sorted alphabetically
  'areasOfFocus',
  'endsGT',
  'functions',
  'isIdealistDay',
  'locale',
  'location',
  'locationType',
  'page',
  'q',
  'radius',
  'recency',
  'sort',
  'source',
  'startsLT',
]);

/**
 * This is not a real path - the path is defined using constants instead of :lang/:segment
 * so that they're more accurate and easier to understand
 */
export const searchOrgsPathReference = rootPrefix.path('-lang/-segment', [
  // sorted alphabetically
  'areasOfFocus',
  'locale',
  'location',
  'orgType',
  'page',
  'q',
  'radius',
  'sort',
]);

/**
 * This is not a real path - the path is defined using constants instead of :lang/:segment
 * so that they're more accurate and easier to understand
 */
export const searchGroupsPathReference = rootPrefix.path('-lang/-segment', [
  // sorted alphabetically
  'locale',
  'location',
  'locationType',
  'page',
  'q',
  'radius',
  'sort',
]);
